import React from 'react';
import { observer } from 'mobx-react';
import Loader from 'react-simple-loading';

import { RootStoreContext } from '../../../../../context';

import Messages from './messages/Messages';
import MessageInput from './message-input/MessageInput';
import BannedSubInfo from './BannedSubInfo/BannedSubInfo';
import ExpiredSubInfo from './ExpiredSubInfo/ExpiredSubInfo';


import './Messaging.css';
import AnchorStore from '../../../../../store/AnchorStore';
import AnchorDashboardStore from '../../../../../store/fragments/AnchorDashboardStore';


@observer
class Messaging extends React.Component {

  static contextType = RootStoreContext;

  renderActiveConversation = () => {
    const {
      privateMessagingStore: {
        conversationSession: { loading, error, session },
        activeConversationHeader,
        isBanned,
        isConversationActive,
        fanCanSendMessages,
      },
      loggedInUser: { account: { anchorSubscriptions, anchor } },
    } = this.context;
    const { anchors } = AnchorStore;
    if (!anchors?.currentAnchors) {
      AnchorStore.setAnchors();
    }

    const isAnchor = !!anchor;
    let subscription = null;
    let shouldShowMessageInput = false;

    if (activeConversationHeader && activeConversationHeader.username) {
      subscription = anchorSubscriptions.
        find((sub) =>
          (sub.anchorUsername === activeConversationHeader.username) ||
          (sub.anchorNickname === activeConversationHeader.username));
      shouldShowMessageInput = (subscription || fanCanSendMessages);

      if (isAnchor) {
        shouldShowMessageInput = true;
      }

      if (!(subscription || isConversationActive) && !isAnchor) {
        return <ExpiredSubInfo anchorInfo={activeConversationHeader} />;
      }
    }

    if (isBanned && !isAnchor) {
      return <BannedSubInfo anchorInfo={activeConversationHeader} />;
    }

    return (
      <>
        {loading && <Loader />}
        {!loading && error && <div>{error}</div>}
        {session && !error && (
          <>
            <Messages anchors={anchors} />
            {
              shouldShowMessageInput &&
              <MessageInput
                anchorSubscriptions={anchorSubscriptions}
                isFan={!anchor}
              />
            }
          </>
        )}
      </>
    );
  };

  render() {
    return (
      <div id="private-chat-messaging">
        {this.renderActiveConversation()}
      </div>
    );
  }
}

export default Messaging;
